import React, { useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import {
	Form,
	FormGroup,
	Label,
	Col,
} from 'reactstrap';
import Select from 'react-select';
import Datetime from 'react-datetime';
import { Get, Post } from '../../function/Koneksi';
import { generateAlamat } from "../../function/Format";

const ModalSuratBelumMenikah = ({ data, optionData, setAlert, isOpen, setIsOpen, statusRefresh, setStatusRefresh, propsData, kiosk }) => {
	const dateFormat = require('dateformat');

	const frmSurat = {
		uuid: '',
		id_jenis: '',
		nik_pelapor: '',
		nik: '',
		nama_pemohon: '',
		tempat_lahir: '',
		tanggal_lahir: '',
		jenis_kelamin: '',
		status_perkawinan: '',
		pekerjaan: '',
		agama: '',
		alamat: '',
		alamat_kk: '',
		pendidikan_terakhir: '',
		kewarganegaraan: '',
		tujuan_pembuatan: '',
	}

	const initFormData = {
		frmNik: optionData.frmNik,
		tmplistPenduduk: optionData.tmplistPenduduk,
		nikStat: null,
		detail: [],
		status: {
			form: false,
			btnForm: false,
			btnAksi: [],
			dataPenduduk: "none",
			frmPreviewDraft: false,
			jenis_form: '',
		},
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",
		
		// Preview surat
		get_data_surat:[],
		get_jenis_surat: "",
	}

	const [formData, setFormData] = useState(initFormData)
	const [props, setProps] = useState(propsData)
	const [kioskMode, setKioskMode] = useState(kiosk)
	const [dt, setDt] = useState(data ? data : frmSurat)
	const [draggable, setDraggable] = useState({
		isDown: false,
		startY: null,
		scrollUp: null,
	})

	useEffect(() => {
		if (document.getElementById("modalForm")) {
			document.getElementById("modalForm").reset()
		}

		setDt(data ? data : frmSurat)
		setFormData(data ? {
			...initFormData,
			nikStat: optionData.nikStat,
			status: optionData.status,
		} : initFormData)
	}, [isOpen])

	const handleInputChangeNIK = (e, fld) => {
		if (e && kioskMode == false) {
			let nikStat = { value: e, label: e };

			Post("penduduk", null, { nik: e }, datanik => {
				let frmNik = [];
				let tmplistPenduduk = {}
				datanik.data.results.data.forEach(dt => {
					frmNik.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
					tmplistPenduduk = {
						...tmplistPenduduk,
						[dt.id]: dt
					}
				});

				switch (fld) {
					case "nik":
						setFormData({
							...formData,
							frmNik,
							tmplistPenduduk,
							nikStat
						})
						break;

					default:
						break;
				}

			});

		}
	};

	const getPenduduk = (e, sel, jns) => {
		if (e) {
			// this.changeSelectValue(e, sel);
			if (kioskMode) {
				props.setLoadingPreview(true)
			}
			else{
				setAlert({
					loadingPreview: true
				})
			}

			Get("penduduk/find", e.value, data => {
				if(data.results){
					const alamat = generateAlamat(data.results);
					let alamat_kk = "";
			
					if(data.results.data_kk){
					  alamat_kk = data.results.data_kk.alamat
					}

					if (jns === "pelapor") {
						if (kioskMode === false) {
							Get("penduduk/kk/"+data.results.id_kk, null, dtkk => {
								let frmNik3 = [];
								let tmplistPenduduk3 = {};
								dtkk.results.forEach(val => {
									frmNik3.push({ value: val.id, label: val.id + ' (' + val.nama + ')' });
									tmplistPenduduk3 = {
										...tmplistPenduduk3,
										[val.id]: val
									}
								});
		
								setFormData({
									...formData,
									nikStat: e,
									frmNik3,
									tmplistPenduduk3,
									status: {
										...formData.status,
										dataPenduduk: "block",
									},
								})
								setDt({
									...dt,
									nik: data.results.id,
									nik_pelapor: data.results.id,
									kk: data.results.id_kk,
									nama_pemohon: data.results.nama,
									tempat_lahir: data.results.tempat_lahir,
									tanggal_lahir: new Date(
										data.results.tanggal_lahir
									),
									pekerjaan: data.results.data_pekerjaan.nama,
									pendidikan_terakhir: data.results.data_pendidikan_terakhir.nama,
									agama: data.results.data_agama.nama,
									status_perkawinan: data.results.status_perkawinan,
									jenis_kelamin: data.results.jk,
									alamat: alamat,
									alamat_kk: alamat_kk,
									kewarganegaraan: 'WNI',
									detail: []
								})
							})
						} else { // Jika mode kiosk langsung set tanpa get list kk keluarga krna sudah ada
							setFormData({
								...formData,
								nikStat: e,
								status: {
									...formData.status,
									dataPenduduk: "block",
								},
							})
							setDt({
								...dt,
								nik: data.results.id,
								nik_pelapor: data.results.id,
								kk: data.results.id_kk,
								nama_pemohon: data.results.nama,
								tempat_lahir: data.results.tempat_lahir,
								tanggal_lahir: new Date(
									data.results.tanggal_lahir
								),
								pekerjaan: data.results.data_pekerjaan.nama,
								pendidikan_terakhir: data.results.data_pendidikan_terakhir.nama,
								agama: data.results.data_agama.nama,
								status_perkawinan: data.results.status_perkawinan,
								jenis_kelamin: data.results.jk,
								alamat: alamat,
								alamat_kk: alamat_kk,
								kewarganegaraan: 'WNI',
								detail: []
							})
						}			
					} else if (jns === "pengikut") {
						let detail = dt.detail
						detail.push({
							nik: data.results.id,
							nama: data.results.nama,
							jenis_kelamin: data.results.jk,
							tanggal_lahir: new Date(
								data.results.tanggal_lahir
							),
							tempat_lahir: data.results.tempat_lahir,
							pekerjaan: data.results.data_pekerjaan.nama,
							pendidikan: data.results.data_pendidikan_terakhir.nama,
							shdk: data.results.data_shdk.nama,
							keterangan: "",
						})
		
						setDt({
							...dt,
							detail
						})
					}
					
					if (kioskMode) {
						props.setLoadingPreview(false);
					}

					setAlert({
						loadingPreview: false
					})
				}	
				else{
					if (kioskMode) {
						props.setLoadingPreview(false);
					}

					setAlert({
						loadingPreview: false
					});
				}
			})

		} else {
			switch (jns) {
				case "pelapor":
					setDt({
						...dt,
						nama_pemohon: '',
						tempat_lahir: '',
						tanggal_lahir: null,
						pekerjaan: '',
						pendidikan_terakhir: '',
						agama: '',
						status_perkawinan: '',
						jenis_kelamin: '',
						alamat: '',
						alamat_kk: '',
						detail: []
					})
					setFormData({
						...formData,
						status: {
							...formData.status,
							dataPenduduk: "none"
						},
						nikStat: null,
						frmNik3: [],
						tmplistPenduduk3: null
					})
					break;
				case "pengikut":
					setFormData({
						...formData,
						nik3Stat: null
					})
					break;
				default:
					break;
			}
		}
	};

	const gantiTgl = (date, fld) => {
		switch (fld) {
		  case "tanggal_shm":
			if (typeof date._isValid !== 'undefined') {
			  let tgl = date.format('YYYY-MM-DD');
						setDt({
							...dt,
							detail_surat:{
								...dt.detail_surat,
								tanggal_shm: new Date(tgl)
							}
						})
			}
			break;
		  default:
			// no default
			break;
		}
	};

	const simpan = (e) => {
		e.preventDefault();

		if (kioskMode){
			props.setLoadingPreview(true)
		}
		else{
			setAlert({
				loadingPreview: true
			})
		}

		let bodyRaw = {
			...dt,
			tujuan_pembuatan: document.getElementById('tujuan_pembuatan').value,
		}

		if (dt.uuid === '') {
			if (kioskMode) {
				bodyRaw.id_jenis = props.id_jenis
			} else {
				bodyRaw.id_jenis = props.location.state.uuid
			}
		}

		let validasiPelapor = formData.nikStat;

		if (validasiPelapor) {

			bodyRaw['tanggal_lahir'] = dateFormat(new Date(dt.tanggal_lahir), 'yyyy-mm-dd');

			let psn = "";
			let resstat = 204;
			let metode = "create";
			if (bodyRaw.uuid === "") {
				psn = "Tambah";
				resstat = 201;
				bodyRaw.uuid = null;
			} else {
				psn = "Ubah";
				resstat = 200;
				metode = "update";
			}
			Post(
				"surat-keterangan/grup/" + metode,
				bodyRaw.uuid,
				bodyRaw,
				res => {

					// For testing
					if (props.resSubmit) {
						props.resSubmit(res.status)
					}

					// this.tutupForm();
					setFormData({
						...formData,
						status: {
							...formData.status,
							btnForm: false,
							form: false,
						}
					})
					setIsOpen(false)

					if (kioskMode) {
						if (res.status === resstat) {
							let dataAntrian = {
								nama: props.data.results.nama,
								nik: props.data.results.id,
								keterangan: '',
								uuid_surat:res.data.results.uuid_surat,
								kode_surat:res.data.results.kode_surat,
							};

							// Set Data Surat
							props.getDataSurat(res.data.results);

							setTimeout(function () {
								Get('persetujuan/kiosk/' + dataAntrian.uuid_surat + '/' + props.id_jenis, null,  (res2) => {

									props.setLoadingPreview(false)

									if (res2.code === 201) {
										props.getAntrian('Surat Keterangan Belum Menikah', 'berhasil', false, dataAntrian);
									}
									else{
										props.getAntrian('Surat Keterangan Belum Menikah', 'gagal');
									}
								});
							}.bind(this),1000)
						} else {
							props.setLoadingPreview(false)
							props.getAntrian('Surat Keterangan Belum Menikah', 'gagal');
						}

					} else {

						if (res.status === resstat) {
							const alertData = {
								get_data_surat:{
									uuid_surat:res.data.results.uuid_surat,
									kode_surat:res.data.results.kode_surat,
								},
								status:{
									frmPreviewDraft: true,
									jenis_form: psn,
								}
								// show: true,
								// basicType: "success",
								// basicTitle: "Data Surat Keterangan Penghasilan",
								// pesanAlert: "Berhasil " + psn + " Data",
								// successAlert: true,
							}
							setAlert({
							  loadingPreview: false
							})
							setAlert(alertData)
						} else {
							const alertData = {
								show: true,
								basicType: "danger",
								basicTitle: "Data Surat Pernyataan Belum Menikah",
								pesanAlert: "Gagal " + psn + " Data"
							}
							setAlert({
							  loadingPreview: false
							})
							setAlert(alertData)
						}

						// Refresh list
						setStatusRefresh(true)

					}

				}
			);
		} else {
			if (kioskMode){
				props.getAntrian('Surat Keterangan Belum Menikah', 'gagal', true);
				props.setLoadingPreview(false)
			}
			else{
				const alertData = {
					show: true,
					basicType: "info",
					basicTitle: "Data Belum Lengkap",
					pesanAlert: "Mohon isi seluruh data dengan benar"
				}
				setAlert({
					loadingPreview: false
				})
				setAlert(alertData)
			}
		}
	};

	return (
		<Modal
			classNames={{ overlay: 'card-scrollable' }}
			open={isOpen}
			onClose={() => {
				setIsOpen(false)
			}}
			closeOnEsc={false}
			closeOnOverlayClick={true}
			style={{
				maxwidth: 'unset'
			}}
		>
			<Form
				id="modalForm"
				data-testid="form-create"
				className="theme-form"
				onSubmit={simpan}
			>
				<div
					onMouseDown={(e) => {
						let slider = document.querySelector('.card-scrollable');
						setDraggable({
							isDown: true,
							startY: e.pageY - slider.offsetTop,
							scrollUp: slider.scrollTop,
						})
					}}
					onMouseLeave={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseUp={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseMove={(e) => {
						e.preventDefault();

						let slider = document.querySelector('.card-scrollable');

						if (!draggable.isDown) {
							return;
						}

						const y = e.pageY - slider.offsetTop;
						const startY = draggable.startY;
						const walk = y - startY;
						slider.scrollTop = draggable.scrollUp - walk;
					}}
				>
				<div className="modal-header">
					<h5 className="modal-title">{dt.uuid == '' ? 'Tambah' : 'Edit'} Surat Pernyataan Belum Menikah</h5>
				</div>
				<div className="modal-body">
					<p>
						Data identitas akan terisi secara otomatis saat NIK dipilih.
						Jika ada ketidak sesuaian data, silakan ubah di data master
						penduduk.
					</p>
					<input
						className="form-control"
						id="uuid"
						type="hidden"
						placeholder=""
						defaultValue={dt.uuid}
					/>

					<FormGroup className="row">
						<Col sm="12">
							<Label className="col-form-label" htmlFor="nik">
								<b>NIK Pemohon</b>
							</Label>
							<div data-testid="selectNIK">
								<Select
									inputId="nik"
									classNamePrefix="select"
									onChange={e => {
										getPenduduk(e, "nik", "pelapor");
									}}
									defaultValue={formData.nikStat}
									value={formData.nikStat}
									name="NIK"
									options={formData.frmNik}
									placeholder="Pilih NIK Pemohon"
									onInputChange={e => handleInputChangeNIK(e, "nik")}
									isClearable
								/>
							</div>
						</Col>
					</FormGroup>
					<div style={{ display: formData.status.dataPenduduk }}>
						<FormGroup className="row">
							<Col sm="12">
								<Label
									className="col-form-label"
									htmlFor="inputEmail3"
								>
									<b>Nama Pemohon</b>
								</Label>
								<input
									className="form-control"
									id="nama"
									type="text"
									placeholder="Nama Pemohon"
									value={dt.nama_pemohon}
									readOnly
									style={{ backgroundColor: "#c9d1d8" }}
									disabled
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Col sm="12">
								<Label
									className="col-form-label"
									htmlFor="inputEmail3"
								>
									<b>Tempat Lahir</b>
								</Label>
								<input
									className="form-control"
									id="tempat_lahir"
									type="text"
									placeholder="Tempat Lahir"
									value={dt.tempat_lahir}
									readOnly

									style={{ backgroundColor: "#c9d1d8" }}
									disabled
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Col sm="12">
								<Label
									className="col-form-label"
									htmlFor="inputEmail3"
								>
									<b>Tanggal Lahir</b>
								</Label>
								<input
									className="form-control"
									id="tanggal_lahir"
									type="text"
									placeholder="Tanggal Lahir"
									value={new Date(dt.tanggal_lahir).toLocaleDateString("id-ID")}
									readOnly
									style={{ backgroundColor: "#c9d1d8" }}
									disabled
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Col sm="12">
								<Label
									className="col-form-label"
									htmlFor="inputEmail3"
								>
									<b>Alamat</b>
								</Label>
								<input
									className="form-control"
									id="alamat_kk"
									type="text"
									placeholder="Alamat"
									value={dt.alamat_kk}
									readOnly

									style={{ backgroundColor: "#c9d1d8" }}
									disabled
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Col sm="12">
								<Label
									className="col-form-label"
									htmlFor="inputEmail3"
								>
									<b>Wilayah</b>
								</Label>
								<input
									className="form-control"
									id="alamat"
									type="text"
									placeholder=""
									value={dt.alamat}
									readOnly

									style={{ backgroundColor: "#c9d1d8" }}
									disabled
								/>
							</Col>
							<Col sm="12">
								<Label
									className="col-form-label"
									htmlFor="inputEmail3"
								>
									&nbsp;
								</Label>
								<small><font color="red">* Jika data wilayah kosong, silahkan perbaiki data alamat kartu keluarga dan pastikan data lengkap terlebih dahulu</font></small>
							</Col>
						</FormGroup>
					</div>
					<FormGroup className="row">
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Tujuan Pembuatan</b>
							</Label>
							<input
								data-testid="tujuan pembuatan"
								name="tujuan_pembuatan"
								className="form-control"
								id="tujuan_pembuatan"
								placeholder="Tambahkan tujuan pembuatan"
								defaultValue={dt.tujuan_pembuatan}
								required
							/>
						</Col>
					</FormGroup>
				</div>
				<div className="modal-footer">
					<button
						type="button"
						className="btn btn-warning"
						onClick={() => {
							// Tutup modal
							setFormData({
								...formData,
								status: {
									...formData.status,
									form: false,
									frmPreviewDraft: false,
									jenis_form: '',
								}
							})
							setIsOpen(false)
						}}
					>
						Tutup
					</button>
					<button
						data-testid="btnSubmitCreate"
						type="submit"
						className="btn btn-primary-custom"
						disabled={formData.status.btnForm}
					>
						Simpan
					</button>
				</div>
				</div>
			</Form>
		</Modal>
	);
}

export default ModalSuratBelumMenikah;
